// packages/frontend/src/components/ToastContainer.tsx
import { useEffect } from 'react'
import { useToastStore } from '../stores/toastStore'
import { X, CheckCircle, XCircle, AlertTriangle, Info } from 'lucide-react'

export function ToastContainer() {
  const { toasts, removeToast, clearToasts } = useToastStore()

  // Clear all toasts when component unmounts or on page reload
  useEffect(() => {
    return () => {
      clearToasts()
    }
  }, [clearToasts])

  const getIcon = (type: string) => {
    switch (type) {
      case 'success':
        return <CheckCircle className="h-5 w-5 text-green-400" />
      case 'error':
        return <XCircle className="h-5 w-5 text-red-400" />
      case 'warning':
        return <AlertTriangle className="h-5 w-5 text-yellow-400" />
      case 'info':
        return <Info className="h-5 w-5 text-blue-400" />
      default:
        return <Info className="h-5 w-5 text-blue-400" />
    }
  }

  const getToastClass = (type: string) => {
    switch (type) {
      case 'success':
        return 'border-green-500 bg-green-500/10'
      case 'error':
        return 'border-red-500 bg-red-500/10'
      case 'warning':
        return 'border-yellow-500 bg-yellow-500/10'
      default:
        return 'border-blue-500 bg-blue-500/10'
    }
  }

  if (toasts.length === 0) {
    return null
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2 pointer-events-none">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`
            pointer-events-auto
            min-w-80 max-w-96
            rounded-lg border
            bg-dark-800/95 backdrop-blur-sm
            p-4 shadow-xl
            animate-slide-up
            ${getToastClass(toast.type)}
          `}
        >
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0">
              {getIcon(toast.type)}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-white break-words">
                {toast.message}
              </p>
            </div>
            <button
              onClick={() => removeToast(toast.id)}
              className="flex-shrink-0 rounded-md p-1 text-dark-400 hover:text-white hover:bg-dark-700 transition-colors"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      ))}
    </div>
  )
}